import { createHashHistory } from 'history'

export default createHashHistory()



// WEBPACK FOOTER //
// ./src/utils/history.js